import * as moment from 'moment';
import { LZString } from '@holmescorp/lz-string';
import { db } from '../database';

export const StateCacheRecordSchema: string = '++, [key+version+language], changed';

export class StateCacheRecord {
	constructor(
		public key: string,
		public version: string,
		public language: string,
		public data: string,
		public changed?: string
	) {
		//
	}

	public async save(): Promise<void> {
		this.changed = moment().toISOString();
		await db.statecache.put(this);
	}

	public age(): number {
		const { changed } = this;
		if (changed) {
			const now = moment();
			const old = moment(changed);
			return now.diff(old, 'hours');
		}
		return 0;
	}
}

export async function get_state<T = { [k: string]: any }>({
	svc_call,
	key,
	version = '_',
	language = 'en'
}: {
	svc_call: () => Promise<T>;
	key: string;
	version?: string;
	language?: string;
}): Promise<T> {
	let record = await db.statecache.where({ key, version, language }).first();
	if (record === undefined) {
		const data = await svc_call();
		record = new StateCacheRecord(key, version, language, LZString.compressToUTF16(JSON.stringify(data)));
		await record.save();
	} else {
		const { sitews } = window.hcstatic;
		if (sitews.is_open() && record.age() > 2) {
			const refresh = async () => {
				const data = await svc_call();
				db.statecache.where({ key, version, language }).modify({
					changed: moment().toISOString(),
					data: LZString.compressToUTF16(JSON.stringify(data))
				});
			};
			refresh();
		}
	}
	return JSON.parse(LZString.decompressFromUTF16(record.data) || '{}');
}
